import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=4356431d&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "../../less/login.less?vue&type=style&index=0&id=4356431d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4356431d",
  null
  
)

export default component.exports